export default "__VITE_ASSET__CgVj2YFs__"